import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a13717c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet1"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  id: "contents1"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "com_inner1 clearfix" }
const _hoisted_7 = {
  key: 1,
  class: "com_breadcrumb1"
}
const _hoisted_8 = { class: "com_contents3" }
const _hoisted_9 = { class: "main_column2" }
const _hoisted_10 = { class: "com_search_result_hd1" }
const _hoisted_11 = { class: "text1" }
const _hoisted_12 = { class: "com_sort_list1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "com_icon_sort1" }),
  /*#__PURE__*/_createTextVNode("並び替え：")
], -1))
const _hoisted_14 = { class: "selected1" }
const _hoisted_15 = { class: "list1" }
const _hoisted_16 = {
  key: 0,
  class: "error-message"
}
const _hoisted_17 = { class: "com_topic_list2" }
const _hoisted_18 = { class: "meta1" }
const _hoisted_19 = { class: "date1 roboto" }
const _hoisted_20 = { class: "com_tag2" }
const _hoisted_21 = { class: "body1" }
const _hoisted_22 = {
  key: 0,
  class: "com_icon_new"
}
const _hoisted_23 = {
  key: 0,
  class: "buttons1"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "edit1"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "side_search_option1" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "com_icon_option1" }),
  /*#__PURE__*/_createTextVNode("さらに絞り込む ")
], -1))
const _hoisted_33 = { class: "block_search1" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title2" }, "キーワードで絞り込む", -1))
const _hoisted_35 = {
  key: 0,
  class: "block_period1"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title2" }, "掲載日で絞り込む", -1))
const _hoisted_37 = ["max"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "t1" }, "〜", -1))
const _hoisted_39 = ["max"]
const _hoisted_40 = {
  key: 0,
  class: "error-message"
}
const _hoisted_41 = {
  key: 1,
  class: "com_checkbox1"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "t2" }, "掲載期間外も表示する", -1))
const _hoisted_43 = { class: "block_options_group1" }
const _hoisted_44 = { class: "com_center1 com_mgb10" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "com_icon_cross1" }, null, -1))
const _hoisted_46 = { class: "hd1" }
const _hoisted_47 = { class: "com_checkbox1" }
const _hoisted_48 = ["onUpdate:modelValue", "onChange"]
const _hoisted_49 = { class: "t1" }
const _hoisted_50 = { class: "body1" }
const _hoisted_51 = ["onUpdate:modelValue", "onChange"]
const _hoisted_52 = { class: "t2" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_54 = { class: "com_center1 com_mgt5" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "com_icon_cross1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_BreadcrumbsComponent = _resolveComponent("BreadcrumbsComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_content_pagination = _resolveComponent("content-pagination")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent)
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.apiErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.apiErrorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.serchCategoryId)
                ? (_openBlock(), _createBlock(_component_BreadcrumbsComponent, {
                    key: _ctx.serchCategoryId,
                    title: "",
                    categoryId: _ctx.serchCategoryId
                  }, null, 8, ["categoryId"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/portal-top" }, {
                          default: _withCtx(() => [
                            _createTextVNode("HOME")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, _toDisplayString(_ctx.categoryName), 1)
                    ])
                  ])),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.dispKeyWord), 1),
                        _createTextVNode(_toDisplayString(_ctx.dispTitle), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("dl", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("dd", null, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currentSortOptionLabel), 1),
                          _createElementVNode("ul", _hoisted_15, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.updateSortOption('new')), ["prevent"]))
                              }, "新着順")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.updateSortOption('category')), ["prevent"]))
                              }, "カテゴリ順")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.updateSortOption('recommend')), ["prevent"]))
                              }, "おすすめ順")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.apiErrorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.apiErrorMessage), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.contentId,
                        class: _normalizeClass({ disabled: _ctx.isProcessing })
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(item.postPeriod), 1),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(item.subCategoryName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_router_link, {
                            to: `/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentId}`,
                            class: "com_link1",
                            onClick: _ctx.handleContentsLinkClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.contentsTitle), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "onClick"]),
                          (item.newFlg)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "NEW"))
                            : _createCommentVNode("", true)
                        ]),
                        (item.fileFlg)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createElementVNode("a", {
                                href: "#",
                                class: "com_dl_button2",
                                onClick: _withModifiers(($event: any) => (
                      _ctx.downloadFiles(item.categoryId, item.contentId)
                    ), ["prevent"])
                              }, _hoisted_26, 8, _hoisted_24)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isKaunetAdmin)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _withModifiers(($event: any) => (
                      _ctx.editContents(
                        item.categoryId,
                        item.contentId,
                        item.updateFormPath
                      )
                    ), ["prevent"]),
                                class: "com_edit1"
                              }, _hoisted_30, 8, _hoisted_28)
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ]),
                  _createVNode(_component_content_pagination, {
                    "current-page": _ctx.currentPage,
                    "total-pages": _ctx.totalPages,
                    "items-per-page": _ctx.itemsPerPage,
                    onPageChanged: _ctx.handlePageChange
                  }, null, 8, ["current-page", "total-pages", "items-per-page", "onPageChanged"])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "",
                        placeholder: "キーワードを入力",
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)), ["enter"])),
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.narrowKeyword) = $event)),
                        maxlength: "50"
                      }, null, 544), [
                        [_vModelText, _ctx.narrowKeyword]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        name: "",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)))
                      })
                    ])
                  ]),
                  (_ctx.isKaunetAdmin || _ctx.isNothiceCategory)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _hoisted_36,
                        _withDirectives(_createElementVNode("input", {
                          class: "date_edit1",
                          type: "date",
                          name: "",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.keisaiKikanFrom) = $event)),
                          max: _ctx.AppConstants.MAX_DATE_VALUE
                        }, null, 8, _hoisted_37), [
                          [_vModelText, _ctx.keisaiKikanFrom]
                        ]),
                        _hoisted_38,
                        _withDirectives(_createElementVNode("input", {
                          class: "date_edit1",
                          type: "date",
                          name: "",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.keisaiKikanTo) = $event)),
                          max: _ctx.AppConstants.MAX_DATE_VALUE
                        }, null, 8, _hoisted_39), [
                          [_vModelText, _ctx.keisaiKikanTo]
                        ]),
                        (_ctx.errorMessage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.errorMessage), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isKaunetAdmin)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_41, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                name: "",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isOutsidePostPeriod) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.isOutsidePostPeriod]
                              ]),
                              _hoisted_42
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "button1",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)))
                        }, " 検索 ")
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "option_uncheck_all1 com_link1",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.uncheckAll && _ctx.uncheckAll(...args)))
                      }, [
                        _hoisted_45,
                        _createTextVNode("チェックを外す ")
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedTags, (group, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "option_group1"
                      }, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("label", _hoisted_47, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((group.isCategoryChecked) = $event),
                              onChange: ($event: any) => (_ctx.toggleCategory(group))
                            }, null, 40, _hoisted_48), [
                              [_vModelCheckbox, group.isCategoryChecked]
                            ]),
                            _createElementVNode("span", _hoisted_49, _toDisplayString(group.categoryName), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.tags, (tag, idx) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: idx,
                              class: "com_checkbox1"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((tag.isChecked) = $event),
                                onChange: ($event: any) => (_ctx.checkCategoryStatus(group, tag))
                              }, null, 40, _hoisted_51), [
                                [_vModelCheckbox, tag.isChecked]
                              ]),
                              _createElementVNode("span", _hoisted_52, _toDisplayString(tag.tagName), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128)),
                    _hoisted_53,
                    _createElementVNode("button", {
                      type: "button",
                      class: "button1",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)))
                    }, " 検索 "),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "option_uncheck_all1 com_link1",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.uncheckAll && _ctx.uncheckAll(...args)))
                      }, [
                        _hoisted_55,
                        _createTextVNode("チェックを外す ")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}